export default __webpack_public_path__ + "static/Guides_2-343c977d0bc45ae890e34c4e7f331653.jpg";